class ConsentService {
    openUi = () =>
        typeof window.__tcfapi === 'function' &&
        window.__tcfapi('displayConsentUi', 2, () => {});
}

export default new ConsentService();
